export default __webpack_public_path__ + "static/media/Gloves of the Blood Drinker.13f43d0b.jpg";